import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'Redux/store';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import './utils/three-compat';

//Views
import MainApp from 'Core/containers/Main';
import ErrorBoundary from 'Components/ErrorBoundary';
import 'Assets/sass/site.scss';

if (window.location.hostname !== "localhost") {
    Sentry.init({
        dsn: "https://262e8b08db1642aa914810d4d1f240f3@o4504373297217536.ingest.sentry.io/4504373549662208",
        integrations: [new BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        enabled: window.location.hostname !== "localhost",
        beforeSend: (event) => {
            if (window.location.hostname === 'localhost') {
              return null;
            }
            return event;
          },
    });
}
const container = document.getElementById('root');
const root = createRoot(container);

const App = () => {
    localStorage.setItem("lan", localStorage.getItem("lan") || "en");

    return (
        <ErrorBoundary>
            <Provider store={store}>
                <BrowserRouter>
                    <Routes>
                        <Route path="*" element={<MainApp />} />
                    </Routes>
                </BrowserRouter>
            </Provider>
        </ErrorBoundary>
    )
}

root.render(<App tab="home" />);